import {DigitalSignatureState} from './states/digital-signature.state';

export const digitalSignatureStates = [
    DigitalSignatureState
];
